// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"437cc7d1","239":"a5ed4216","453":"8f70c201","732":"6f01cf4b"}[chunkId] + ".chunk.js";
};